/*!
 * @pixi/mixin-get-child-by-name - v6.3.0
 * Compiled Wed, 23 Mar 2022 18:58:56 UTC
 *
 * @pixi/mixin-get-child-by-name is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
import{DisplayObject as i,Container as e}from"@pixi/display";i.prototype.name=null,e.prototype.getChildByName=function(i,e){for(var r=0,t=this.children.length;r<t;r++)if(this.children[r].name===i)return this.children[r];if(e)for(r=0,t=this.children.length;r<t;r++){if(this.children[r].getChildByName){var h=this.children[r].getChildByName(i,!0);if(h)return h}}return null};
//# sourceMappingURL=mixin-get-child-by-name.min.js.map
